// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"75e06cd7","570":"79b7536a","581":"10da57ab","747":"a3ab3595","926":"a631fad7"}[chunkId] + ".chunk.css";
};